import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';

const FONTE = '"Roboto", "Helvetica", "Arial", sans-serif';
const LARANJA = '#df622e';

export const PainelNotificacoes = styled(Menu)({
  '& .MuiMenu-paper': {
    width: '380px',
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: '460px',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 12px 32px rgba(17, 24, 39, .16)',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '6px',
  },
  '& .MuiMenu-list': {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '460px',
  },
});

export const HeaderNotificacoes = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 18px 12px',
  borderBottom: '1px solid #EEF0F3',
});

export const Titulo = styled('h1')({
  margin: 0,
  fontSize: '17px',
  fontWeight: 700,
  fontFamily: FONTE,
  color: '#111827',
});

export const ContadorNovas = styled('span')({
  fontFamily: FONTE,
  fontSize: '12px',
  fontWeight: 600,
  color: LARANJA,
  backgroundColor: '#FDEEE7',
  borderRadius: '999px',
  padding: '3px 10px',
});

export const Notificacoes = styled('div')({
  overflowY: 'auto',
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: '#E5E7EB',
  },
});

export const MensagemSemNotificacoes = styled('div')({
  minHeight: '240px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  padding: '24px',
  color: '#9CA3AF',
});

export const Mensagem = styled('p')({
  margin: 0,
  fontSize: '14px',
  fontFamily: FONTE,
  color: '#6B7280',
  textAlign: 'center',
});

export const Item = styled('div', {
  shouldForwardProp: (prop) => prop !== 'naoLida',
})(({ naoLida }) => ({
  position: 'relative',
  borderRadius: '12px',
  padding: '12px 14px 12px 16px',
  backgroundColor: naoLida ? '#FFF6F1' : 'transparent',
  transition: 'background-color .15s',
  wordWrap: 'break-word',
  '&:hover': {
    backgroundColor: naoLida ? '#FDEEE7' : '#F7F8FA',
  },
}));

export const ItemTopo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '6px',
});

export const LogoPrograma = styled('img')({
  height: '18px',
  width: 'auto',
  maxWidth: '96px',
  objectFit: 'contain',
});

export const PontoNaoLida = styled('span')({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: LARANJA,
  flexShrink: 0,
});

export const ItemTitulo = styled('h2')({
  margin: '0 0 4px',
  fontFamily: FONTE,
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 1.35,
  color: '#111827',
});

export const ItemDescricao = styled('p')({
  margin: 0,
  fontFamily: FONTE,
  fontSize: '13px',
  lineHeight: 1.45,
  color: '#4B5563',
});
